/** #REPORTS, #EXPORTS */

export const REPORT_TYPES = {
  gifted_children: 1,
  members_requests: 2,
  verified_tasks: 3,
  tasks_awaiting_evaluation: 5,
  experts_number: 6,
  teams_number_completed_all_tasks: 7,
  teams_number_not_completed_tasks: 8,
  teams_number_completed_not_all_tasks: 9,
  completed_tasks_number: 10,
  started_tasks_number_not_completed: 11,
  number_requests_members_teams: 12,
  teams_number_on_and_another_level: 13,
  template_importing_members_into_event: 14,
  events_statistics: 15,
  created_events_statistics: 17,
  multilevel_event_members_information: 18,
  multilevel_event_teams_information: 19,
  operator_summary_events_table: 20,
  operator_summary_members_table: 21,
  department_summary_events_table: 22,
  department_summary_members_table: 23,
  examination_report: 24,
  event_stage_members: 25,
  event_stage_members_reward: 26,
  olympics_protocol: 27,
  gifted_children_detailed: 28,
  event_expertises_simple_score: 29,
  olympics_protocol_levels: 30,
  event_stage_team_manage: 31,
  event_stage_team_control: 32,
  event_stage_team_reward: 33,
  event_owner_change: 34,
  template_importing_members_into_event_by_nomination: 40,
  // nomination_subject_completed_or_not: 41,

  tournament_event_stage_public: 50,
  tournament_event_stage_private: 51,
  tournament_event_stage_users_list: 52,

  level_transfer_member_force: 53,
  subordinated_members_count: 54,
  export_members_by_nominations: 55,
  local_level_members: 56,
  tournament_event_stage_rejected_users_list: 58,
  tournament_event_stage_excluded_users_list: 59,
  tournament_event_stage_request_users_list: 60,

  certificates_templates: 100,
};

export const REPORT_EXPORT_TYPES = [
  REPORT_TYPES.verified_tasks,
  REPORT_TYPES.tasks_awaiting_evaluation,
  REPORT_TYPES.experts_number,
  REPORT_TYPES.teams_number_completed_all_tasks,
  REPORT_TYPES.teams_number_not_completed_tasks,
  REPORT_TYPES.teams_number_completed_not_all_tasks,
  REPORT_TYPES.completed_tasks_number,
  REPORT_TYPES.started_tasks_number_not_completed,
  REPORT_TYPES.number_requests_members_teams,
  REPORT_TYPES.teams_number_on_and_another_level,
  REPORT_TYPES.events_statistics,
  REPORT_TYPES.multilevel_event_members_information,
  REPORT_TYPES.multilevel_event_teams_information,
  REPORT_TYPES.operator_summary_events_table,
  REPORT_TYPES.operator_summary_members_table,
  REPORT_TYPES.department_summary_events_table,
  REPORT_TYPES.department_summary_members_table,
  REPORT_TYPES.examination_report,
  REPORT_TYPES.olympics_protocol,
  REPORT_TYPES.event_expertises_simple_score,
  REPORT_TYPES.olympics_protocol_levels,
  // REPORT_TYPES.nomination_subject_completed_or_not,
  REPORT_TYPES.tournament_event_stage_public,
  REPORT_TYPES.tournament_event_stage_private,
  REPORT_TYPES.tournament_event_stage_users_list,
];

// Регик
export const OPERATOR_REPORTS_TYPES = [
  REPORT_TYPES.gifted_children,
  REPORT_TYPES.events_statistics,
  REPORT_TYPES.created_events_statistics,
  REPORT_TYPES.operator_summary_events_table,
  REPORT_TYPES.operator_summary_members_table,
  REPORT_TYPES.teams_number_completed_not_all_tasks,
];

// Муник
export const DEPARTMENT_REPORT_TYPES = [
  REPORT_TYPES.gifted_children,
  REPORT_TYPES.events_statistics,
  REPORT_TYPES.created_events_statistics,
  REPORT_TYPES.department_summary_events_table,
  REPORT_TYPES.department_summary_members_table,
  REPORT_TYPES.teams_number_completed_not_all_tasks,
];

const REPORT_COLUMN_KEY = {
  id: 'ID',
  region: 'регион',
  municipality: 'муниципалитет',
  eventStartAt: 'начало мероприятия',
  eventEndAt: 'конец мероприятия',
  occupiedPlace: 'занятое место',
  pointsCount: 'количество баллов',
  pollsWithAssessment: 'количество оцененных заданий',
  pollsWithoutAssessment: 'количество заданий без оценки',
  expertsCount: 'количество экспертов',
  eventId: 'ID мероприятия',
  teamsCount: 'количество команд',
  completedPollsCount: 'количество завершенных заданий',
  organization: 'организация',
  organizationContactEmail: 'контактный email организатора',
  requestsCountFull: 'количество заявок пользователей (принятые, непринятые, отклоненные, на доработку)',
  number: 'номер',
  level: 'уровень',
  organizer: 'организатор',
  organizerContactEmail: 'контактный email организатора',
  eventMembersCount: 'число участников в мероприятии',
  membersTotalCount: 'число участников, всего (региональный, муниципальный и локальный уровни)',
  membersRegionCount: 'число участников в регионе (муниципалитет и локальный уровни)',
  membersMunicipalityCount: 'число участников в муниципалитете (локальный уровень)',
  eventTeamsCount: 'число команд в мероприятии',
  teamsTotalCount: 'число команд, всего (региональный, муниципальный и локальный уровни)',
  teamsRegionCount: 'число команд в регионе (муниципалитет и локальный уровни)',
  teamsMunicipalityCount: 'число команд в муниципалитете (локальный уровень)',
  expertiseId: 'ID экспертизы',
  fullName: 'ФИО',
  age: 'возраст',
  nomination: 'номинация',
  expertFullName: 'ФИО эксперта',
  criterionAssessment: 'критерий:оценка',
  totalPoints: 'всего баллов',
  educationOrganization: 'образовательная организация',
  memberFullName: 'ФИО участника',
  class: 'класс',
  cipher: 'шифр',
  sum: 'сумма',
  result: 'результат',
  status: 'статус',
  fromCountry: 'из какой страны',
  email: 'адрес эл. почты',
  currentSchool: 'в какой школе учился',
  certificateNumber: 'номер сертификата',
  lastName: 'фамилия',
  firstName: 'имя',
  middleName: 'отчество',
  requestStatus: 'статус заявки',
  regionId: 'ID региона',
  regionName: 'наименование региона',
  createdCount: 'количество созданных',
  notCreatedCount: 'количество несозданных',
  publishedCount: 'количество опубликованных',
  draftsCount: 'количество черновиков',
  one: '1',
  two: '2',
  three: '3',
  eventNameBrackets: 'мероприятие (название)',
  eventLinkBrackets: 'мероприятие (ссылка)',
  eventEntryDate: 'дата занесения',
  eventDates: 'даты проведения',
  organizerContacts: 'контактные данные организатора',
  direction: 'направленность',
  eventMemberType: 'тип участия',
  enrolledMembersCount: 'количество зачисленных участников',
  giftedChildrensCount: 'количество одаренных детей',
  hasHigherEvents: 'наличие вышестоящих мероприятий',
  hasLowerEvents: 'наличие нижестоящих',
  hashTag: '#',
  eventName: 'название мероприятия',
  eventOrganizer: 'организатор мероприятия',
  membersCount: 'число участников',
  eventLevel: 'уровень мероприятия',
  isEventProjectPart: 'мероприятие реализуется в рамках проекта',
  eventFocus: 'направленность мероприятия',
  eventType: 'тип мероприятия',
  start: 'начало',
  end: 'конец',
  year: 'год',
  memberLastName: 'фамилия участника',
  memberFirstName: 'имя участника',
  memberMiddleName: 'отчество участника',
  participitionResult: 'результат участия',
  eventPeriod: 'период проведения',
  eventDirection: 'направление мероприятия',
  eventNaming: 'наименование мероприятия',
  expert: 'эксперт',
  comment: 'комментарий',
  memberFullNameOrTeamName: 'ФИО участника/наименование команды',
};

export const REPORT_TYPES_DATA = {
  [REPORT_TYPES.gifted_children]: {
    id: REPORT_TYPES.gifted_children,
    name: 'Одаренные дети',
    columns: [
      REPORT_COLUMN_KEY.id,
      REPORT_COLUMN_KEY.fullName,
      REPORT_COLUMN_KEY.region,
      REPORT_COLUMN_KEY.municipality,
      REPORT_COLUMN_KEY.eventId,
      REPORT_COLUMN_KEY.eventStartAt,
      REPORT_COLUMN_KEY.eventEndAt,
      REPORT_COLUMN_KEY.occupiedPlace,
      REPORT_COLUMN_KEY.pointsCount,
    ],
  },
  [REPORT_TYPES.members_requests]: {
    id: REPORT_TYPES.members_requests,
    name: 'Заявки участников',
    columns: [
      REPORT_COLUMN_KEY.region,
      REPORT_COLUMN_KEY.municipality,
      REPORT_COLUMN_KEY.age,
      REPORT_COLUMN_KEY.certificateNumber,
      REPORT_COLUMN_KEY.lastName,
      REPORT_COLUMN_KEY.firstName,
      REPORT_COLUMN_KEY.middleName,
      REPORT_COLUMN_KEY.class,
      REPORT_COLUMN_KEY.requestStatus,
      REPORT_COLUMN_KEY.fromCountry,
      REPORT_COLUMN_KEY.email,
      REPORT_COLUMN_KEY.currentSchool,
    ],
  },
  [REPORT_TYPES.verified_tasks]: {
    id: REPORT_TYPES.verified_tasks,
    name: 'Проверенные задания',
    columns: [
      REPORT_COLUMN_KEY.region,
      REPORT_COLUMN_KEY.municipality,
      REPORT_COLUMN_KEY.pollsWithAssessment,
      //
    ],
  },
  [REPORT_TYPES.tasks_awaiting_evaluation]: {
    id: REPORT_TYPES.tasks_awaiting_evaluation,
    name: 'Задания, ожидающие оценки',
    columns: [
      REPORT_COLUMN_KEY.region,
      REPORT_COLUMN_KEY.municipality,
      REPORT_COLUMN_KEY.pollsWithoutAssessment,
      //
    ],
  },
  [REPORT_TYPES.experts_number]: {
    id: REPORT_TYPES.experts_number,
    name: 'Количество экспертов',
    columns: [
      REPORT_COLUMN_KEY.region,
      REPORT_COLUMN_KEY.municipality,
      REPORT_COLUMN_KEY.expertsCount,
      //
    ],
  },
  [REPORT_TYPES.teams_number_completed_all_tasks]: {
    id: REPORT_TYPES.teams_number_completed_all_tasks,
    name: 'Количество команд, которые выполнили все задания в мероприятии',
    columns: [
      REPORT_COLUMN_KEY.eventId,
      REPORT_COLUMN_KEY.region,
      REPORT_COLUMN_KEY.municipality,
      REPORT_COLUMN_KEY.teamsCount,
      //
    ],
  },
  [REPORT_TYPES.teams_number_not_completed_tasks]: {
    id: REPORT_TYPES.teams_number_not_completed_tasks,
    name: 'Количество команд, не выполняли задания',
    columns: [
      REPORT_COLUMN_KEY.eventId,
      REPORT_COLUMN_KEY.region,
      REPORT_COLUMN_KEY.municipality,
      REPORT_COLUMN_KEY.teamsCount,
      //
    ],
  },
  [REPORT_TYPES.teams_number_completed_not_all_tasks]: {
    id: REPORT_TYPES.teams_number_completed_not_all_tasks,
    name: 'Количество команд, которые выполнили не все задания в мероприятии',
    columns: [
      REPORT_COLUMN_KEY.eventId,
      REPORT_COLUMN_KEY.region,
      REPORT_COLUMN_KEY.municipality,
      REPORT_COLUMN_KEY.teamsCount,
      //
    ],
  },
  [REPORT_TYPES.completed_tasks_number]: {
    id: REPORT_TYPES.completed_tasks_number,
    name: 'Количество выполненных заданий',
    columns: [
      REPORT_COLUMN_KEY.region,
      REPORT_COLUMN_KEY.municipality,
      REPORT_COLUMN_KEY.completedPollsCount,
      //
    ],
  },
  [REPORT_TYPES.started_tasks_number_not_completed]: {
    id: REPORT_TYPES.started_tasks_number_not_completed,
    name: 'Количество незавершеных заданий',
    columns: [
      REPORT_COLUMN_KEY.region,
      REPORT_COLUMN_KEY.municipality,
      REPORT_COLUMN_KEY.completedPollsCount,
      //
    ],
  },
  [REPORT_TYPES.number_requests_members_teams]: {
    id: REPORT_TYPES.number_requests_members_teams,
    name: 'Количество заявок, участников, команд',
    columns: [
      REPORT_COLUMN_KEY.region,
      REPORT_COLUMN_KEY.municipality,
      REPORT_COLUMN_KEY.organization,
      REPORT_COLUMN_KEY.organizationContactEmail,
      REPORT_COLUMN_KEY.requestsCountFull,
    ],
  },
  [REPORT_TYPES.teams_number_on_and_another_level]: {
    id: REPORT_TYPES.teams_number_on_and_another_level,
    name: 'Количество команд, допущенных на текущее мероприятие',
    columns: [
      REPORT_COLUMN_KEY.region,
      REPORT_COLUMN_KEY.municipality,
      REPORT_COLUMN_KEY.teamsCount,
      //
    ],
  },
  [REPORT_TYPES.template_importing_members_into_event]: {
    id: REPORT_TYPES.template_importing_members_into_event,
    name: 'Шаблон импорта участников в мероприятие',
  },
  [REPORT_TYPES.events_statistics]: {
    id: REPORT_TYPES.events_statistics,
    name: 'Статистика мероприятий',
    columns: [
      REPORT_COLUMN_KEY.eventNameBrackets,
      REPORT_COLUMN_KEY.eventLinkBrackets,
      REPORT_COLUMN_KEY.eventEntryDate,
      REPORT_COLUMN_KEY.eventDates,
      REPORT_COLUMN_KEY.organizer,
      REPORT_COLUMN_KEY.level,
      REPORT_COLUMN_KEY.direction,
      REPORT_COLUMN_KEY.eventMemberType,
      REPORT_COLUMN_KEY.enrolledMembersCount,
      REPORT_COLUMN_KEY.giftedChildrensCount,
      REPORT_COLUMN_KEY.hasHigherEvents,
      REPORT_COLUMN_KEY.hasLowerEvents,
    ],
  },
  [REPORT_TYPES.created_events_statistics]: {
    id: REPORT_TYPES.created_events_statistics,
    name: 'Статистика созданных мероприятий',
    columns: [
      REPORT_COLUMN_KEY.regionId,
      REPORT_COLUMN_KEY.regionName,
      REPORT_COLUMN_KEY.createdCount,
      REPORT_COLUMN_KEY.notCreatedCount,
      REPORT_COLUMN_KEY.publishedCount,
      REPORT_COLUMN_KEY.draftsCount,
    ],
  },
  [REPORT_TYPES.multilevel_event_members_information]: {
    id: REPORT_TYPES.multilevel_event_members_information,
    name: 'Шедевральный отчет: участники',
    columns: [
      REPORT_COLUMN_KEY.number,
      REPORT_COLUMN_KEY.level,
      REPORT_COLUMN_KEY.organizer,
      REPORT_COLUMN_KEY.organizerContactEmail,
      REPORT_COLUMN_KEY.region,
      REPORT_COLUMN_KEY.municipality,
      REPORT_COLUMN_KEY.eventMembersCount,
      REPORT_COLUMN_KEY.membersTotalCount,
      REPORT_COLUMN_KEY.membersRegionCount,
      REPORT_COLUMN_KEY.membersMunicipalityCount,
    ],
  },
  [REPORT_TYPES.multilevel_event_teams_information]: {
    id: REPORT_TYPES.multilevel_event_teams_information,
    name: 'Шедевральный отчет: команды',
    columns: [
      REPORT_COLUMN_KEY.number,
      REPORT_COLUMN_KEY.level,
      REPORT_COLUMN_KEY.organizer,
      REPORT_COLUMN_KEY.organizerContactEmail,
      REPORT_COLUMN_KEY.region,
      REPORT_COLUMN_KEY.municipality,
      REPORT_COLUMN_KEY.eventTeamsCount,
      REPORT_COLUMN_KEY.teamsTotalCount,
      REPORT_COLUMN_KEY.teamsRegionCount,
      REPORT_COLUMN_KEY.teamsMunicipalityCount,
    ],
  },
  [REPORT_TYPES.operator_summary_events_table]: {
    id: REPORT_TYPES.operator_summary_events_table,
    name: 'Сводная таблица по мероприятиям',
    columns: [
      REPORT_COLUMN_KEY.hashTag,
      REPORT_COLUMN_KEY.eventName,
      REPORT_COLUMN_KEY.eventOrganizer,
      REPORT_COLUMN_KEY.membersCount,
      REPORT_COLUMN_KEY.eventLevel,
      REPORT_COLUMN_KEY.municipality,
      REPORT_COLUMN_KEY.municipality,
      REPORT_COLUMN_KEY.isEventProjectPart,
      REPORT_COLUMN_KEY.eventFocus,
      REPORT_COLUMN_KEY.eventType,
      REPORT_COLUMN_KEY.start,
      REPORT_COLUMN_KEY.end,
      REPORT_COLUMN_KEY.year,
    ],
  },
  [REPORT_TYPES.operator_summary_members_table]: {
    id: REPORT_TYPES.operator_summary_members_table,
    name: 'Сводная таблица по участникам',
    columns: [
      REPORT_COLUMN_KEY.memberLastName,
      REPORT_COLUMN_KEY.memberFirstName,
      REPORT_COLUMN_KEY.memberMiddleName,
      REPORT_COLUMN_KEY.age,
      REPORT_COLUMN_KEY.participitionResult,
      REPORT_COLUMN_KEY.municipality,
      REPORT_COLUMN_KEY.eventNaming,
      REPORT_COLUMN_KEY.eventLevel,
      REPORT_COLUMN_KEY.eventDirection,
      REPORT_COLUMN_KEY.eventType,
      REPORT_COLUMN_KEY.isEventProjectPart,
      REPORT_COLUMN_KEY.eventPeriod,
    ],
  },
  [REPORT_TYPES.department_summary_events_table]: {
    id: REPORT_TYPES.department_summary_events_table,
    name: 'Сводная таблица по мероприятиям',
    columns: [
      REPORT_COLUMN_KEY.hashTag,
      REPORT_COLUMN_KEY.eventName,
      REPORT_COLUMN_KEY.eventOrganizer,
      REPORT_COLUMN_KEY.membersCount,
      REPORT_COLUMN_KEY.eventLevel,
      REPORT_COLUMN_KEY.municipality,
      REPORT_COLUMN_KEY.isEventProjectPart,
      REPORT_COLUMN_KEY.eventFocus,
      REPORT_COLUMN_KEY.eventType,
      REPORT_COLUMN_KEY.start,
      REPORT_COLUMN_KEY.end,
      REPORT_COLUMN_KEY.year,
    ],
  },
  [REPORT_TYPES.department_summary_members_table]: {
    id: REPORT_TYPES.department_summary_members_table,
    name: 'Сводная таблица по участникам',
    columns: [
      REPORT_COLUMN_KEY.memberFullName,
      REPORT_COLUMN_KEY.age,
      REPORT_COLUMN_KEY.participitionResult,
      REPORT_COLUMN_KEY.municipality,
      REPORT_COLUMN_KEY.eventNaming,
      REPORT_COLUMN_KEY.eventLevel,
      REPORT_COLUMN_KEY.eventDirection,
      REPORT_COLUMN_KEY.eventType,
      REPORT_COLUMN_KEY.isEventProjectPart,
      REPORT_COLUMN_KEY.eventPeriod,
    ],
  },
  [REPORT_TYPES.event_stage_members]: {
    id: REPORT_TYPES.event_stage_members,
    name: 'Отчёт по участникам этапа',
  },
  [REPORT_TYPES.examination_report]: {
    id: REPORT_TYPES.examination_report,
    name: 'Отчет по экспертизе c критериями',
    columns: [
      REPORT_COLUMN_KEY.expertiseId,
      REPORT_COLUMN_KEY.fullName,
      REPORT_COLUMN_KEY.region,
      REPORT_COLUMN_KEY.municipality,
      REPORT_COLUMN_KEY.age,
      REPORT_COLUMN_KEY.nomination,
      REPORT_COLUMN_KEY.expertFullName,
      REPORT_COLUMN_KEY.criterionAssessment,
      REPORT_COLUMN_KEY.totalPoints,
    ],
  },
  [REPORT_TYPES.event_stage_members_reward]: {
    id: REPORT_TYPES.event_stage_members_reward,
    name: 'Отчёт по наградам участников этапа',
  },
  [REPORT_TYPES.olympics_protocol]: {
    id: REPORT_TYPES.olympics_protocol,
    name: 'Протокол олимпиады',
    columns: [
      REPORT_COLUMN_KEY.number,
      REPORT_COLUMN_KEY.educationOrganization,
      REPORT_COLUMN_KEY.memberFullName,
      REPORT_COLUMN_KEY.class,
      REPORT_COLUMN_KEY.cipher,
      REPORT_COLUMN_KEY.one,
      REPORT_COLUMN_KEY.two,
      REPORT_COLUMN_KEY.three,
      REPORT_COLUMN_KEY.sum,
      REPORT_COLUMN_KEY.result,
      REPORT_COLUMN_KEY.status,
      REPORT_COLUMN_KEY.fromCountry,
      REPORT_COLUMN_KEY.currentSchool,
    ],
  },
  [REPORT_TYPES.gifted_children_detailed]: {
    id: REPORT_TYPES.gifted_children_detailed,
    name: 'Детализированный список',
  },
  [REPORT_TYPES.event_expertises_simple_score]: {
    id: REPORT_TYPES.event_expertises_simple_score,
    name: 'Отчет по экспертизам командный и для участников',
    columns: [
      REPORT_COLUMN_KEY.memberFullNameOrTeamName,
      REPORT_COLUMN_KEY.municipality,
      REPORT_COLUMN_KEY.expert,
      REPORT_COLUMN_KEY.totalPoints,
      REPORT_COLUMN_KEY.comment,
    ],
  },
  [REPORT_TYPES.olympics_protocol_levels]: {
    id: REPORT_TYPES.olympics_protocol_levels,
    name: 'Протокол олимпиады по уровням',
    columns: [
      REPORT_COLUMN_KEY.number,
      REPORT_COLUMN_KEY.educationOrganization,
      REPORT_COLUMN_KEY.memberFullName,
      REPORT_COLUMN_KEY.class,
      REPORT_COLUMN_KEY.cipher,
      REPORT_COLUMN_KEY.one,
      REPORT_COLUMN_KEY.two,
      REPORT_COLUMN_KEY.three,
      REPORT_COLUMN_KEY.sum,
      REPORT_COLUMN_KEY.result,
      REPORT_COLUMN_KEY.status,
      REPORT_COLUMN_KEY.fromCountry,
      REPORT_COLUMN_KEY.currentSchool,
    ],
  },
  [REPORT_TYPES.event_stage_team_manage]: {
    id: REPORT_TYPES.event_stage_team_manage,
    name: 'Команды',
  },
  [REPORT_TYPES.event_stage_team_control]: {
    id: REPORT_TYPES.event_stage_team_control,
    name: 'Допуск к этапам',
  },
  [REPORT_TYPES.event_stage_team_reward]: {
    id: REPORT_TYPES.event_stage_team_reward,
    name: 'Награждения',
  },
  [REPORT_TYPES.event_owner_change]: {
    id: REPORT_TYPES.event_owner_change,
    name: 'Задания и результаты',
  },
  [REPORT_TYPES.template_importing_members_into_event_by_nomination]: {
    id: REPORT_TYPES.template_importing_members_into_event_by_nomination,
    name: 'Шаблон импорта участников в мероприятие с дополнительными полями номинации',
  },
  // [REPORT_TYPES.nomination_subject_completed_or_not]: {
  //   id: REPORT_TYPES.nomination_subject_completed_or_not,
  //   name: 'Проведен / не проведен предмет',
  //   columns: [
  //     REPORT_COLUMN_KEY.educationOrganization,
  //     REPORT_COLUMN_KEY.nomination,
  //   ],
  // },
  [REPORT_TYPES.tournament_event_stage_public]: {
    id: REPORT_TYPES.tournament_event_stage_public,
    name: 'Публичный',
  },
  [REPORT_TYPES.tournament_event_stage_private]: {
    id: REPORT_TYPES.tournament_event_stage_private,
    name: 'Для внутреннего использования',
  },
  [REPORT_TYPES.tournament_event_stage_users_list]: {
    id: REPORT_TYPES.tournament_event_stage_users_list,
    name: 'Список участников',
  },
  [REPORT_TYPES.tournament_event_stage_rejected_users_list]: {
    id: REPORT_TYPES.tournament_event_stage_rejected_users_list,
    name: 'Список отклонённых участников',
  },
  [REPORT_TYPES.tournament_event_stage_excluded_users_list]: {
    id: REPORT_TYPES.tournament_event_stage_excluded_users_list,
    name: 'Список исключённых участников',
  },
  [REPORT_TYPES.tournament_event_stage_request_users_list]: {
    id: REPORT_TYPES.tournament_event_stage_request_users_list,
    name: 'Список заявок на рассмотрении',
  },
  [REPORT_TYPES.level_transfer_member_force]: {
    id: REPORT_TYPES.level_transfer_member_force,
    name: 'Список участников нижестоящего уровня',
  },
  [REPORT_TYPES.subordinated_members_count]: {
    id: REPORT_TYPES.subordinated_members_count,
    name: 'Сводные результаты участия на нижестоящем уровне',
    columns: [],
  },
  [REPORT_TYPES.export_members_by_nominations]: {
    id: REPORT_TYPES.export_members_by_nominations,
    name: 'Участники по номинациям',
    columns: [],
  },
  [REPORT_TYPES.local_level_members]: {
    id: REPORT_TYPES.local_level_members,
    name: 'Участники локального уровня',
    columns: [],
  },
  [REPORT_TYPES.certificates_templates]: {
    id: REPORT_TYPES.certificates_templates,
    name: 'Отчёт по грамотам и дипломам',
  },
};

export const REPORT_TYPES_LIST = Object.values(REPORT_TYPES_DATA);

export const REPORT_STATUS = {
  STARTED: 1,
  GENERATING: 2,
  READY: 3,
  ERROR: 4,
};

export const REPORT_STATUS_TEXT = {
  [REPORT_STATUS.STARTED]: 'Формируется',
  [REPORT_STATUS.GENERATING]: 'В процессе',
  [REPORT_STATUS.READY]: 'Выполнен',
  [REPORT_STATUS.ERROR]: 'Ошибка',
};

export const REPORT_STATUS_DATA = {
  [REPORT_STATUS.STARTED]: {
    text: REPORT_STATUS_TEXT[REPORT_STATUS.STARTED],
    icon: '$iinfo',
    attrs: {
      color: 'ui-info',
      get textColor() {
        return `${this.color}--text`;
      },
    },
  },
  [REPORT_STATUS.GENERATING]: {
    text: REPORT_STATUS_TEXT[REPORT_STATUS.GENERATING],
    icon: '$iclock-outline',
    attrs: {
      color: 'ui-warning',
      get textColor() {
        return `${this.color}--text`;
      },
    },
  },
  [REPORT_STATUS.READY]: {
    text: REPORT_STATUS_TEXT[REPORT_STATUS.READY],
    icon: '$icheck-outline-circle',
    attrs: {
      color: 'ui-success',
      get textColor() {
        return `${this.color}--text`;
      },
    },
  },
  [REPORT_STATUS.ERROR]: {
    text: REPORT_STATUS_TEXT[REPORT_STATUS.ERROR],
    icon: '$iclose-outline-circle',
    attrs: {
      color: 'ui-error',
      get textColor() {
        return `${this.color}--text`;
      },
    },
  },
};

export const IMPORT_STATUS = {
  not_passed: 1,
  success: 2,
  importing: 3,
  fail: 4,
  valid_fail: 5,
  passed: 6,
};

export const IMPORT_STATUS_DATA = {
  [IMPORT_STATUS.not_passed]: {
    text: 'Ожидает импорта',
    icon: '$ui-time',
    attrs: {
      color: 'ui-neitral',
      get backgroundColor() {
        return `${this.color} lighten-4`;
      },
      get textColor() {
        return `${this.color}--text`;
      },
    },
  },
  [IMPORT_STATUS.passed]: {
    text: 'Дублирующие данные',
    icon: '$ui-attention',
    attrs: {
      color: 'ui-warning',
      get backgroundColor() {
        return `${this.color} lighten-4`;
      },
      get textColor() {
        return `${this.color}--text`;
      },
    },
  },
  [IMPORT_STATUS.importing]: {
    text: 'Импортируем',
    icon: '$ui-time',
    attrs: {
      color: 'ui-warning',
      get backgroundColor() {
        return `${this.color} lighten-4`;
      },
      get textColor() {
        return `${this.color}--text`;
      },
    },
  },
  [IMPORT_STATUS.fail]: {
    text: 'Ошибка импорта',
    icon: '$ui-attention',
    attrs: {
      color: 'ui-error',
      get backgroundColor() {
        return `${this.color} lighten-4`;
      },
      get textColor() {
        return `${this.color}--text`;
      },
    },
  },
  [IMPORT_STATUS.valid_fail]: {
    text: 'Ошибка данных',
    icon: '$ui-attention-mini',
    attrs: {
      color: 'ui-error',
      get backgroundColor() {
        return `${this.color} lighten-4`;
      },
      get textColor() {
        return `${this.color}--text`;
      },
    },
  },
  [IMPORT_STATUS.success]: {
    text: 'Импортирован',
    icon: '$ui-check',
    attrs: {
      color: 'ui-success',
      get backgroundColor() {
        return `${this.color} lighten-4`;
      },
      get textColor() {
        return `${this.color}--text`;
      },
    },
  },
};
